// Reference:
// * https://github.com/shadcn-ui/ui/blob/3740373f99e39943514a45f5808ecb5f17faf700/apps/v4/registry/new-york-v4/ui/sonner.tsx
// * https://github.com/dev-xo/remix-saas/blob/4ebba831f0d72693b77210629915586cd6071a20/app/components/ui/sonner.tsx

import { Toaster as Sonner, type ToasterProps } from "sonner";

import type { Theme } from "@/theme/theme";

const Toaster = ({ theme, ...props }: ToasterProps & { theme: Theme }) => {
  return (
    <Sonner
      className="toaster group"
      theme={theme}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground font-medium",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground font-medium",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
